<!-- dynamic-question-builder.component.html -->
<div class="container">
    <div class="header">
        <h1>Dynamic Question Builder</h1>
        <p>Create and customize different types of questions dynamically</p>
    </div>

    <div class="controls">
        <select class="question-type-select" [(ngModel)]="selectedType">
            <option value="subjective">Subjective</option>
            <option value="objective">Objective</option>
            <option value="checklist">Checklist</option>
            <option value="radio">Radio Option</option>
            <option value="rating">Rating</option>
            <option value="file">File Uploader</option>
        </select>
        <button class="btn btn-primary" (click)="addQuestion()">Add Question</button>
        <button class="btn btn-secondary" (click)="clearAll()">Clear All</button>
    </div>

    <div class="questions-container">
        <div class="question-card" *ngFor="let question of questions; let i = index">
            <div class="question-header">
                <div class="question-number">{{ i + 1 }}</div>
                <div class="question-type-badge">{{ question.type }}</div>
                <button class="delete-btn" (click)="removeQuestion(question.id)">×</button>
            </div>

            <div class="form-group">
                <label class="form-label">Question Title</label>
                <input type="text" class="form-input" placeholder="Enter your question..." [(ngModel)]="question.title">
            </div>

            <div class="form-group">
                <label>
                    <input type="checkbox" [(ngModel)]="question.required">
                    Required Question
                </label>
            </div>

            <!-- Options for checklist/radio -->
            <div *ngIf="question.type === 'checklist' || question.type === 'radio'" class="form-group">
                <label class="form-label">Options</label>
                <div class="options-container">
                    <div *ngFor="let option of question.options; let j = index">
                        <input type="text" [ngModel]="option" (ngModelChange)="question.options![j] = $event"
                            placeholder="Enter option..." />
                        <button class="remove-option" (click)="removeOption(question, j)">×</button>
                    </div>
                </div>
                <button class="add-option-btn" (click)="addOption(question)">+ Add Option</button>
            </div>

            <!-- Rating Config -->
            <div *ngIf="question.type === 'rating'" class="form-group">
                <label class="form-label">Rating Scale</label>
                <div class="rating-config">
                    <div>
                        <label>Min:</label>
                        <input type="number" class="form-input rating-input" [(ngModel)]="question.minRating">
                    </div>
                    <div>
                        <label>Max:</label>
                        <input type="number" class="form-input rating-input" [(ngModel)]="question.maxRating">
                    </div>
                </div>
            </div>

            <!-- File Config -->
            <div *ngIf="question.type === 'file'" class="form-group">
                <label class="form-label">Accepted File Types</label>
                <input type="text" class="form-input" placeholder="e.g., .jpg,.png,.pdf"
                    [(ngModel)]="question.acceptedFileTypes">
            </div>
        </div>
    </div>

    <div class="preview-section">
        <h3 class="preview-title">Form Preview</h3>
        <div *ngIf="questions.length === 0" class="no-questions">No questions added yet. Add some questions to see the
            preview.</div>

        <div *ngFor="let question of questions; let i = index" class="question-preview">
            <div class="preview-question-title">{{ i + 1 }}. {{ question.title || 'Untitled Question' }} <span
                    *ngIf="question.required">*</span></div>

            <textarea *ngIf="question.type === 'subjective'" class="preview-input preview-textarea"
                placeholder="Enter your answer..."></textarea>
            <input *ngIf="question.type === 'objective'" type="text" class="preview-input"
                placeholder="Enter your answer...">

            <div *ngIf="question.type === 'checklist'" class="preview-options">
                <div class="preview-option" *ngFor="let option of question.options">
                    <input type="checkbox"> <label>{{ option }}</label>
                </div>
            </div>

            <div *ngIf="question.type === 'radio'" class="preview-options">
                <div class="preview-option" *ngFor="let option of question.options">
                    <input type="radio" [name]="'radio-' + question.id"> <label>{{ option }}</label>
                </div>
            </div>

            <div *ngIf="question.type === 'rating'" class="rating-stars">
                <span class="star" *ngFor="let r of [].constructor(question.maxRating); let idx = index">&#9733;</span>
            </div>

            <div *ngIf="question.type === 'file'" class="file-upload-area">
                <p>Click to upload or drag and drop</p>
                <p><small>Accepted formats: {{ question.acceptedFileTypes || 'All files' }}</small></p>
                <input type="file" class="file-upload-input" [attr.accept]="question.acceptedFileTypes">
            </div>
        </div>

        <div class="export-buttons">
            <button class="btn btn-success" (click)="exportJSON()">Export as JSON</button>
        </div>
    </div>
</div>